var winTop = 0;
function lockScroll() {
	winTop = $(window).scrollTop();
	$('body').addClass('lock-scroll');
	$('body').css({'top': (winTop * -1) + 'px'});
}
function unlockScroll() {
	$('body').removeClass('lock-scroll');
	$('body').css({'top': ''});
	$(window).scrollTop(winTop);
}

var wishlistItems = [];
var productCardMarkup = `{{#products}}
													<div class="product-tile wishlist-item" data-productid="{{empi}}">
															<div class="upper-row">
																	<div class="tile-image" style="background: url('{{iu}}')no-repeat center / cover;">
																			<img src="{{iu}}" alt="{{ product.title }} - image"/>
																			<a href="{{du}}"></a>
																	</div>
																	<p class="product-title">{{dt}}</p>
																	<p class="product-price">\₱{{pr}}</p>
															</div>
															<div class="col-remove"><button class="wishlist-remove" data-product-id="{{empi}}">Remove from wishlists</button></div>
													</div>
													{{/products}}`;

function getVariantInfo(variants){
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
		if(variantKeys.length > 0){
			variantinfo = variantKeys[0];
			if(variantinfo == "Default Title"){
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch(err){
		return variants;
	}
}

var wishlistProductObjects = [];

function swymCallbackFn(){
	// gets called once Swym is ready
	var wishlistContentsContainer = document.getElementById("wishlist-items");
	_swat.fetchWrtEventTypeET(
		function(products) {
			// Get wishlist items
			console.log('wishlist products', products);
			wishlistProductObjects = products;
			checkExistingWishlist();
			var formattedWishlistedProducts = products.map(function(p){
				p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
				p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
				p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
				return p;
			});

			if (wishlistContentsContainer) {
				var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
				wishlistContentsContainer.innerHTML = productCardsMarkup;
			}

			attachClickListeners();

			const wishlistCount = products.length || '';
			$('.wishlist-item-count').text(wishlistCount);
			if (!wishlistCount) {
				$('.wishlist-item-count').addClass('d-none');
			} else {
				$('.wishlist-item-count').removeClass('d-none');
			}
		},
		window._swat.EventTypes.addToWishList
	);
}
if(!window.SwymCallbacks){
	window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);


function onAddToCartClick(e){
	e.preventDefault();
	var productId = e.target.getAttribute("data-product-id");
	var variantId = e.target.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart(
		{empi: productId, du: du},
		variantId,
		function() {
			// console.log("Successfully added product to cart.");
			e.target.innerHTML = "Added to cart";
			$(e.target).attr('disabled', '');
			$(document).trigger('cart.add.swym');
		},
		function(e) {
		//  console.log(e);
		}
	);
}

function onRemoveWishListClick(e){
	e.preventDefault();
	var productId = e.target.getAttribute('data-product-id');
	removeFromWishlistCustom(productId);
}

function removeFromWishlistCustom(id) {
	var wishlistTarget = wishlistItems.find(wishItem => wishItem.empi == id)
	const {
		epi,
		du,
		empi,
		iu,
		pr,
		stk,
		variants
	} = wishlistTarget

	window._swat.removeFromWishList(
			{
				"epi": epi,
				"du": du,
				"empi": empi,
				"iu": iu,
				"pr": pr,
				"stk": stk,
				"variants": variants
			},
			function(r) {
				// console.log('Removed to wishlist');
				$(`.product-tile.wishlist-item[data-productid="${r.empi}"]`).remove();
				$(`.swym-added[data-product-id="${r.empi}"]`)
					.removeClass('swym-added')
					.removeAttr('disabled');

				const wishlistCount = $('.product-tile.wishlist-item').length || '';
				$('.wishlist-item-count').text(wishlistCount);
				if (!wishlistCount) {
					$('.wishlist-item-count').addClass('d-none');
				} else {
					$('.wishlist-item-count').removeClass('d-none');
				}

				fetchWishlist();
			}
	);
}

function addToWishListCustom(e) {
	// console.log('add to wishlist custom ---------');
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var productObj = SwymViewProducts[productId];
	var thisBtn = e.currentTarget;
	var objToAdd = {};


	if (SwymViewProducts[productId]) {
		objToAdd = {
			"epi": SwymViewProducts[productId].epi,
			"du": SwymViewProducts[productId].du,
			"dt": SwymViewProducts[productId].dt,
			"empi": SwymViewProducts[productId].empi,
			"iu" : SwymViewProducts[productId].iu,
			"pr": SwymViewProducts[productId].pr,
			"stk": SwymViewProducts[productId].stk,
			"variants": SwymViewProducts[productId].variants
		}
	} else {
		objToAdd = {
			"epi": $('#quickview-modal').data('epi'),
			"du": window.location.origin + $('#quickview-modal').data('du'),
			"dt": $('#quickview-modal').data('dt'),
			"empi": $('#quickview-modal').data('empi'),
			"iu": $('#quickview-modal').data('iu'),
			"pr": $('#quickview-modal').data('pr')
		}
	}

	// console.log(SwymViewProducts[productId]);
	window._swat.addToWishList(objToAdd,
		function(r) {
			// console.log('Added to wishlist');
			$('body').addClass('wishlist-active');
			lockScroll();
			$(`.btn-add-wishlist[data-product-id="${$(thisBtn).data('product-id')}"]`).addClass('swym-added');
			$(thisBtn).addClass('swym-added').attr('disabled', 'disabled');
			$('body').removeClass('empty-wishlist');
			appendWishlistRow(objToAdd);

			const wishlistCount = $('.wishlist-row-item').length || '';
			$('.wishlist-item-count').text(wishlistCount);
			if (!wishlistCount) {
				$('.wishlist-item-count').addClass('d-none');
			} else {
				$('.wishlist-item-count').removeClass('d-none');
			}

			setTimeout(function() {
				$('body').removeClass('wishlist-active');
				unlockScroll();
			}, 2500);
		}
	);
}

function onQuickViewOpen() {
	if(wishlistItems.some( item  =>  $('#quickview-modal').attr('data-empi' ) == item.empi )) {
		$('#quickview-modal .btn-add-wishlist')
			.addClass('swym-added')
			.attr('disabled', 'disabled');
	} else {
		$('#quickview-modal .btn-add-wishlist')
			.removeClass('swym-added')
			.removeAttr('disabled');
	}
}

function appendWishlistRow(productData) {
	// console.log('append to wishlist drawer ---------');

	var ctr = 0;
	var variantLabel = '';

	if (Array.isArray(productData.variants) && productData.variants.length > 0) {
		$.each(productData.variants[0], function(key, value) {
			if (ctr == 0 && key != 'Default Title') {
				variantLabel = key;
			} else {
				variantLabel = '';
			}
			ctr++;
		})
	}
	var productRowWishlistHTML = `<div class="product-tile wishlist-item" data-productid="${productData.empi}">
																	<div class="upper-row">
																			<div class="tile-image" style="background: url('${productData.iu}')no-repeat center / cover;">
																					<img src="${productData.iu}" alt="{{ product.title }} - image"/>
																					<a href="${productData.du}"></a>
																			</div>
																			<p class="product-title">${productData.dt}</p>
																			<p class="product-price">\₱${productData.pr}</p>
																	</div>
																	<div class="col-remove"><button class="wishlist-remove" data-product-id="${productData.empi}">Remove from wishlists</button></div>
															</div>`;
	if ($('.product-tile.wishlist-item[data-productid="'+productData.empi+'"]').length == 0) {
		$('#wishlist-items').prepend(productRowWishlistHTML);
	}

	fetchWishlist();
}

function fetchWishlist() {
	window._swat.fetch((res) => {
		// console.log('fetch')
		wishlistItems = res;
		console.log('res', res.length);
		if (res.length > 0) {
			$('body').removeClass('empty-wishlist');
		} else {
			$('body').addClass('empty-wishlist');
		}
	})
}

function checkExistingWishlist() {
	$('.btn-add-wishlist').each(function() {
		var thisId = $(this).attr('data-product-id');
		var thisBtn = $(this);
		$.each(wishlistProductObjects, function(index, obj){
			if (thisId == obj.empi) {
				$('button[data-product-id="'+obj.empi+'"]').addClass('swym-added');
			}
		})
	});
	fetchWishlist();
}

function attachClickListeners(){
	$(document).on('click', '.wishlist-add-to-cart', onAddToCartClick);

	$(document).on('click', '.wishlist-remove', onRemoveWishListClick);
	$(document).on('click', '.wishlist-remove-all', function() {
		wishlistItems.forEach(function(item) {
			removeFromWishlistCustom(item.empi);
		})
		// $('.wishlist-remove').trigger('click');
	});

	$(document).on('click', '.btn-add-wishlist', addToWishListCustom);
	$(document).on('click', '.btn-add-wishlist.swym-added', onRemoveWishListClick);


	$(document).on('show.quickview', onQuickViewOpen);
}